import React, { useState, useEffect, useRef } from 'react';
import './Collapse.style.css';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const Collapse = ({
  title,
  titleStyle = {},
  children,
  contentStyle = {},
  defaultOpened = false,
  maxHeight,
  icon = (open) => (open ? <UpOutlined /> : <DownOutlined />),
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpened);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen, children]); // children이 변경될 때 contentHeight를 업데이트

  const handleToggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="collapse_layout">
      <div
        className="collapse_header"
        onClick={() => handleToggleCollapse()}
        style={{ ...titleStyle }}
      >
        <h4>{title}</h4>
        <span>{icon(isOpen)}</span>
      </div>
      <div
        ref={contentRef}
        className={`collapse_content ${isOpen ? 'open' : ''}`}
        style={{
          maxHeight: isOpen
            ? maxHeight
              ? maxHeight
              : contentHeight
              ? `${contentHeight}px`
              : '100%'
            : 0,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease',
          ...contentStyle,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Collapse;
